/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetActivityQueryResponse,
  GetActivityPathParams,
} from '../models/GetActivity.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getActivityQueryResponseSchema } from '../zod/getActivitySchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getActivityQueryKey = (id: GetActivityPathParams['id']) =>
  [{ url: '/api/activities/:id', params: { id: id } }] as const;

export type GetActivityQueryKey = ReturnType<typeof getActivityQueryKey>;

/**
 * {@link /api/activities/:id}
 */
export async function getActivity(
  id: GetActivityPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetActivityQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: 'GET', url: `/api/activities/${id}`, ...requestConfig });
  return getActivityQueryResponseSchema.parse(res.data);
}

export function getActivityQueryOptions(
  id: GetActivityPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getActivityQueryKey(id);
  return queryOptions<
    GetActivityQueryResponse,
    ResponseErrorConfig<Error>,
    GetActivityQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getActivity(id, config);
    },
  });
}

/**
 * {@link /api/activities/:id}
 */
export function useGetActivity<
  TData = GetActivityQueryResponse,
  TQueryData = GetActivityQueryResponse,
  TQueryKey extends QueryKey = GetActivityQueryKey,
>(
  id: GetActivityPathParams['id'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetActivityQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getActivityQueryKey(id);

  const query = useQuery(
    {
      ...getActivityQueryOptions(id, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
